import NodeHandler from "../node_handler";


class ToggleableText extends NodeHandler{
    __init_dom_schema(){
        return {
            button: {
                selector: '.js-toggleable-text__button',
                actions: {
                    'click': this.onToggle.bind(this),
                }
            },
            // text: '.js-toggleable-text__text',
        }
    }
    __init() { }
    onToggle(event){
        this.node.classList.toggle('is--toggled')
    }
}

export default ToggleableText;